import { Checkbox } from "../../../ui/index.ts";
import { ACKNOWLEDGMENT, BUSINESS_FIELDS, BUSINESS_TYPES, CONSULTANT_FIELDS, DOCUMENTS, PAYMENT_FIELDS, PAYMENT_METHODS, PAYMENT_TERMS, type ConsultantUsValues } from "./consultant-us.config.ts";
import type { ConsultantDocuments } from "./consultant-us-documents.tsx";
import styles from "./consultant-us.module.css";

export function ConsultantUsReview({ values, files, acknowledged, onAcknowledge, error }: {
  values: ConsultantUsValues;
  files: ConsultantDocuments;
  acknowledged: boolean;
  onAcknowledge: (checked: boolean) => void;
  error?: string;
}) {
  const label = (options: { value: string; label: string }[], value: string) => options.find((option) => option.value === value)?.label || "Not provided";
  const sections = [
    { title: "Consultant Information", rows: CONSULTANT_FIELDS.map((field) => [field.label, values[field.key]]) },
    { title: "Business & Tax Information", rows: [
      ...BUSINESS_FIELDS.map((field) => [field.label, values[field.key]]),
      ["Business Type", values.businessType === "other" ? values.otherBusinessType : label(BUSINESS_TYPES, values.businessType)],
    ] },
    { title: "Payment Information", rows: [
      ["Payment Method", label(PAYMENT_METHODS, values.paymentMethod)],
      ...PAYMENT_FIELDS.map((field) => [field.label, values[field.key]]),
      ["Payment Terms", values.paymentTerms === "other" ? values.otherPaymentTerms : label(PAYMENT_TERMS, values.paymentTerms)],
    ] },
    { title: "Compliance Documents", rows: DOCUMENTS.map((document) => [document.label, files[document.id]?.name || "Not attached"]) },
  ];
  return (
    <div className={styles.stack}>
      {sections.map((section) => (
        <section key={section.title}>
          <h3 className="heading-sm mb-3">{section.title}</h3>
          <dl className={styles.grid}>
            {section.rows.map(([name, value]) => (
              <div key={name} className={styles.detail}><dt className="body-sm text-accent">{name}</dt><dd className="body-sm">{value || "Not provided"}</dd></div>
            ))}
          </dl>
        </section>
      ))}
      <section className={styles.acknowledgment}>
        <h3 className={styles.sectionTitle}>Consultant Acknowledgment</h3>
        <Checkbox id="consultant-us-acknowledgment" label={ACKNOWLEDGMENT} checked={acknowledged} onChange={onAcknowledge} />
        {error && <p className={styles.error} role="alert">{error}</p>}
      </section>
    </div>
  );
}
